import React from 'react';
import { StyleSheet, View, Text, ScrollView, Platform } from 'react-native';
import { FAB } from 'react-native-paper';

const BodhiProtect = () => {
    const handleDownload = () => {
        if (Platform.OS === 'web') {
            const pdfAsset = require('../../assets/bodhiprotect-terms-conditions.pdf');
            const link = document.createElement('a');
            link.href = pdfAsset;
            link.download = 'bodhiprotect-terms-conditions.pdf';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } else {
            // Native download functionality can be added here in the future
            console.log('Download not supported on this platform');
        }
    };

    return (
        <View style={styles.container}>
            <ScrollView>
                <View style={styles.contentContainer}>
                    <View style={styles.content}>
                        <Text style={styles.title}>Bodhi Protect Terms and Conditions</Text>
                        <Text style={styles.subtitle}>For Rentals Placed After December 31, 2025</Text>

                        <Text style={styles.sectionTitle}>Definitions</Text>
                        <Text style={styles.bulletPoint}>
                            <Text style={styles.bold}>• Renter</Text> – You and the others in your group for your Rental. Renter also defines the person who purchased Bodhi Protect and will receive refund of Rental Value. "You" and "your" also refer to Renter.
                        </Text>
                        <Text style={styles.bulletPoint}>
                            <Text style={styles.bold}>• Rental</Text> – Is the rental item(s) and/or experience(s) you purchased from a Bodhisys Using Company.
                        </Text>
                        <Text style={styles.bulletPoint}>
                            <Text style={styles.bold}>• Rental Value</Text> – Is the amount of the purchase you made with the Bodhisys Using Company prior to any taxes, Bodhi Protect cost, and any other non-Rental costs. Rental Value is the amount you will be refunded.
                        </Text>
                        <Text style={styles.bulletPoint}>
                            <Text style={styles.bold}>• Rental Start Time</Text> – One second after midnight (00:00:01) the day your Rental starts. It is not the opening time of Bodhisys Using Company nor anticipated or stated start time of Rental.
                        </Text>
                        <Text style={styles.bulletPoint}>
                            <Text style={styles.bold}>• Bodhisys Using Company</Text> – Is the company with which you have your Rental.
                        </Text>
                        <Text style={styles.bulletPoint}>
                            <Text style={styles.bold}>• Bodhi Protect</Text> – This is the service provided by the Bodhisys Using Company that allows Renter to cancel their Rental subject to the provisions in these Terms and Conditions.
                        </Text>
                        <Text style={styles.bulletPoint}>
                            <Text style={styles.bold}>• Bodhisys</Text> - The company that provides the refund service of Bodhi Protect. Bodhisys is not affiliated with Bodhisys Using Company
                        </Text>

                        <Text style={styles.sectionTitle}>What is Bodhi Protect?</Text>
                        <Text style={styles.paragraph}>
                            If Renter cancels Rental on Renter's own initiative at least 24 hours before Rental Start Time, Bodhi Protect will refund 100% of the rental value listed in your confirmation email. Additional services or fees will not be refunded.
                        </Text>
                        <Text style={styles.paragraph}>
                            Bodhi Protect starts at 12:01 AM UTC on the day after you purchase Rental and lasts until 24 hours before Rental Start Time.
                        </Text>
                        <Text style={styles.paragraph}>
                            Bodhi Protect is not insurance but is rather a product provided by Bodhi Protect, which is not an insurance company.
                        </Text>

                        <Text style={styles.sectionTitle}>What is excluded?</Text>
                        <Text style={styles.paragraph}>
                            Bodhi Protect will not cover cancellations of any Rental initiated by Bodhisys Using Company. Additionally Bodhi Protect will not cover cancellations less than 24 hours before Rental Start Time of your Rental.
                        </Text>
                        <Text style={styles.paragraph}>
                            Bodhi Protect will not cover cancelations due to "Acts of God" or mandates by any government agency for circumstances outside of Bodhisys Using Comany's control including floods, weather emergencies, fires, named storms, curfews, or pandemics.
                        </Text>

                        <Text style={styles.sectionTitle}>What's the cost?</Text>
                        <Text style={styles.paragraph}>
                            Bodhi Protect costs a listed percentage of Rental Value depending on the type of Rental.
                        </Text>
                        <Text style={styles.paragraph}>
                            Bodhi Protect is non-refundable, even in the event that you do not use Bodhi Protect.
                        </Text>

                        <Text style={styles.sectionTitle}>How to use</Text>
                        <Text style={styles.paragraph}>
                            If you decide to cancel your Rental at your own initiative at least 24 hours before the Rental Start Time and you purchased Bodhi Protect at time of Rental, Bodhi Protect will refund 100% of the Rental Value listed in your confirmation email. Additional services or fees will not be refunded. As an example, if your Rental starts on Saturday, Renter must request refund prior to midnight the Thursday prior.
                        </Text>
                        <Text style={styles.paragraph}>
                            There is no proof or documentation required to use Bodhi Protect. Bodhi Protect attempts to refund Rental Value refund requests in 24-72 hours of the request if Renter properly follows these Terms and Conditions.
                        </Text>

                        <Text style={styles.subsectionTitle}>Specific steps:</Text>
                        <Text style={styles.paragraph}>
                            Please click refund request link at least 24 hours before your Rental Start Time if you wish to cancel and receive a refund. You will need to provide some basic information, including Renter name, Order ID Number, the date of your Rental, and a brief explanation of your cancellation reason.
                        </Text>
                        <Text style={styles.paragraph}>
                            Bodhi Protect will reach out via email to confirm that your Rental cancellation meets the provision of these Terms and Conditions and will be processed or if it fails to meet the conditions for refund.
                        </Text>
                        <Text style={styles.paragraph}>
                            Following a positive confirmation, Bodhi Protect will issue you a refund. Refunds will be made in $USD and processed via the same credit card as Renter used to pay for Rental. Please note it may take 5 to 7 business days for the funds to be returned to your account. This time is outside our control and is based on Renter's credit card policy.
                        </Text>

                        <Text style={styles.sectionTitle}>Questions on how to use?</Text>
                        <Text style={styles.paragraph}>
                            Servicing and refund decision of Bodhi Protect are exclusively provided by Bodhi Protect. To ensure prompt service, all questions should be directed to Bodhi Protect, not Bodhisys Using Company. In the event of difficulties understanding or using Bodhi Protect, please visit our Contact Us Page for convenient ways to reach us. Contacting Bodhisys Using Company with questions and/or requests relating to use of Bodhi Protect shall void Renter's Bodhi Protect and Renter's opportunity to receive a refund of their Rental Value.
                        </Text>
                    </View>
                </View>
            </ScrollView>
            <FAB
                style={styles.fab}
                icon="download"
                onPress={handleDownload}
                color="#fff"
            />
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: '#282828',
    },
    contentContainer: {
        maxWidth: 960,
        marginHorizontal: 'auto',
        backgroundColor: '#fff',
    },
    content: {
        padding: 20,
        paddingBottom: 40,
    },
    title: {
        fontSize: 26,
        fontWeight: 'bold',
        marginBottom: 8,
        color: '#000',
        textAlign: 'center',
    },
    subtitle: {
        fontSize: 18,
        marginBottom: 24,
        color: '#666',
        textAlign: 'center',
    },
    sectionTitle: {
        fontSize: 22,
        fontWeight: 'bold',
        marginTop: 20,
        marginBottom: 12,
        color: '#000',
    },
    subsectionTitle: {
        fontSize: 18,
        fontWeight: 'bold',
        marginTop: 12,
        marginBottom: 8,
        color: '#000',
    },
    paragraph: {
        fontSize: 16,
        lineHeight: 24,
        marginBottom: 12,
        color: '#333',
    },
    bulletPoint: {
        fontSize: 16,
        lineHeight: 24,
        marginBottom: 12,
        color: '#333',
    },
    bold: {
        fontWeight: 'bold',
    },
    fab: {
        position: 'absolute',
        margin: 16,
        right: 0,
        bottom: 0,
        backgroundColor: '#007AFF',
    },
});

export default BodhiProtect;